import type { QuoteAddonOffer } from '@/gen/cortado/v1/invoices_pb'
import { ItemUnitEnum } from '@/gen/cortado/v1/settings_pb'
import { stringToItemUnitEnum } from '@/lib/enum-utils'

import type { QuoteAddonOfferFormValue } from './quote-addon-offers-table'

export function haveQuoteAddonOffersChanged(
  original: readonly QuoteAddonOffer[],
  updated: readonly QuoteAddonOfferFormValue[],
): boolean {
  if (original.length !== updated.length) return true

  return original.some((origOffer, index) => {
    const updatedOffer = updated[index]
    if (!updatedOffer) return true

    const origUnitEnum = origOffer.unit
      ? stringToItemUnitEnum(origOffer.unit)
      : ItemUnitEnum.ITEM_UNIT_PER_EVENT

    return (
      origOffer.sourceItemId !== updatedOffer.sourceItemId ||
      origOffer.name !== updatedOffer.name ||
      (origOffer.description ?? '') !== (updatedOffer.description ?? '') ||
      Number(origOffer.unitPriceCents) !== updatedOffer.unitPriceCents ||
      origOffer.quantity !== updatedOffer.quantity ||
      origUnitEnum !== updatedOffer.unit ||
      origOffer.sortOrder !== updatedOffer.sortOrder ||
      origOffer.isTaxable !== updatedOffer.isTaxable ||
      origOffer.salesTaxRateId !== updatedOffer.salesTaxRateId ||
      origOffer.salesTaxRateName !== updatedOffer.salesTaxRateName ||
      origOffer.salesTaxRate !== updatedOffer.salesTaxRate
    )
  })
}
